// removed by extract-text-webpack-plugin
module.exports = {"container_dash":"styles__container_dash___3rqvf","box":"styles__box___3uPfc","first_column":"styles__first_column___2LbSn","second_column":"styles__second_column___29RjL","third_column":"styles__third_column___D4dLi","error_box":"styles__error_box___1PYzP","fixedVoice":"styles__fixedVoice___2d3Ci","header_dash":"styles__header_dash___BVUlC","buttons":"styles__buttons___3OzMN"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/Pages/Dashboard/styles.css
// module id = 3198
// module chunks = 0